import React, { useEffect, useState } from "react";
import * as url from "../../../../helpers/url_helper";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import ConfirmationModal from "../../../../components/Common/ConfirmationModal";
import ChipsDataTable from "./ChipsDetail/ChipsDataTable";
import { AssignIcon, DeleteIcon, MqttIcon } from "../../../../assets/svg";
import AssignRoomModal from "./AssignRoomModal";
import { ActionButton } from "../../../../components/Common/button";
import Request from "../../../../helpers/request";

export interface LockControlProps {
  userId: any;
  selectedPremise?: any;
}
function DriverList({ userId ,selectedPremise}: LockControlProps) {
  const selectedRooms = useSelector(
    (state: any) => state.APIResponse.selectedRooms
  );
  const token = localStorage.getItem("Authorization");

  const [isMultiDeleteModalOpen, setMultiDeleteModalOpen] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteData, setDeleteData] = useState<any>();
  const [isReload, setReload] = useState<boolean>(false);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [assignData, setAssignData] = useState<any>({});
  const [isAssignRoomModalOpen, setIsAssignRoomModalOpen] = useState(false);
  const columns = [
    {
      name: "Device Id",
      selector: (row: any) => row?.deviceId || "-",
      sortable: true,
      grow: 1.5,
      wrap: true,
    },
    {
      name: "Slave",
      selector: (row: any) => row?.slave || "-",
      sortable: true,
      grow: 1.5,
      wrap: true,
    },
    {
      name: "	HW-V",
      selector: (row: any) => row.hwVersion || "-",
      sortable: true,
      grow: 0.5,
      wrap: true,
    },
    {
      name: "	WI-V",
      selector: (row: any) => row.wifiVersion || "-",
      sortable: true,
      grow: 0.5,
      wrap: true,
    },
    {
      name: "	Room Name",
      selector: (row: any) => row.roomName || "-",
      sortable: true,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row: any) => (row.isOnline ? "Online" : "Offline"),
      cell: (row: any) =>
        row.isOnline === true ? (
          <span className="font-size-11 badge-soft-success badge bg-secondary">
            online
          </span>
        ) : (
          <span className="font-size-11 badge-soft-danger badge bg-secondary">
            Offline
          </span>
        ),
      sortable: true,
      grow: 0.5,
      wrap: true,
    },
    {
      name: "	Model",
      selector: (row: any) => row.modelType || "-",
      sortable: true,
      grow: 1.5,
      wrap: true,
    },

    {
      name: "Actions",
      grow: 2,
      cell: (row: any) => (
        <div className="d-flex align-items-center" style={{ gap: "12px" }}>
          <button
            onClick={() => handleDeleteClick(row)}
            title="Delete"
            className="btn p-0 m-0 border-0 bg-transparent"
            style={{ lineHeight: 1 }}
          >
            <DeleteIcon />
          </button>
          <button
            onClick={() => handleMQTTData(row)}
            title="MQTT"
            className="btn p-0 m-0 border-0 bg-transparent"
            style={{ lineHeight: 1 }}
          >
            <MqttIcon />
          </button>
          <ActionButton
            id="AssignIconButton"
            title="Assign Room"
            icon={<AssignIcon />}
            onClick={() => handleAssignClick(row)}
          />
        </div>
      ),
    },
  ];

  const handleRefresh = () => {
    setReload((prev) => !prev);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleRefresh();
    }, 30000);

    return () => clearInterval(interval);
  }, []);
  const deleteDriverApiCall = () => {
    setDeleteModalOpen(false);

    setLoading(true);
    const reqObj = {
      iotDeviceId: [deleteData._id],
    };

    Request.delete(url.DELETE_IOT_DEVICE, reqObj)
      .then((res) => {
        toast.success(res.data.msg);
        handleRefresh();
        setDeleteModalOpen(false);
        setDeleteData(null);
        setLoading(false);
      })
      .catch((err) => {
        const errorMsg =
          err?.response?.data?.msg ||
          "Something went wrong while deleting the device.";
        toast.error(errorMsg);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDeleteClick = (rowData: any) => {
    setDeleteModalOpen(!isDeleteModalOpen);
    setDeleteData(rowData);
  };

  const multiDeleteDriverApiCall = () => {
    setMultiDeleteModalOpen(false);
    setLoading(true);
    const reqObj = {
      iotDeviceId: selectedRows?.map((item) => item._id),
    };
    Request.delete(url.DELETE_IOT_DEVICE, reqObj)
      .then((res) => {
        toast.success(res.data.msg);
        handleRefresh();
        setDeleteModalOpen(false);
        setDeleteData(null);
        setLoading(false);
      })
      .catch((err) => {
        const errorMsg =
          err?.response?.data?.msg ||
          "Something went wrong while deleting the device.";
        toast.error(errorMsg);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleDeleteAll = () => {
    setMultiDeleteModalOpen(!isMultiDeleteModalOpen);
  };

  const handleMQTTData = (rowData: any) => {
    rowData?.slave
      ? window.open(`/debug-device-details/${rowData?.slave}`, "_blank")
      : "";
  };
  const handleAssignClick = (row: any) => {
    if (row !== undefined) {
      setIsAssignRoomModalOpen(!isAssignRoomModalOpen);
      setAssignData(row);
    }
  };

  return (
    <div>
      {isDeleteModalOpen && (
        <ConfirmationModal
          headerTitle="Delete Driver?"
          text="Are you sure you want to delete this Driver ? This action cannot be undone."
          buttonText="Delete"
          onClick={() => {
            deleteDriverApiCall();
          }}
          cancleBtnClick={() => setDeleteModalOpen(false)}
          loading={loading}
        />
      )}
      {isMultiDeleteModalOpen && (
        <ConfirmationModal
          headerTitle="Delete Driver?"
          text="Are you sure you want to delete this Driver? This action cannot be undone."
          buttonText="Delete"
          onClick={() => {
            multiDeleteDriverApiCall();
          }}
          cancleBtnClick={() => setMultiDeleteModalOpen(false)}
          loading={loading}
        />
      )}
      {isAssignRoomModalOpen && (
        <AssignRoomModal
          headerTitle="Assign Room"
          idName={"Driverlist"}
          assignData={assignData}
          handleRefresh={handleRefresh}
          cancleBtnClick={() => {
            setIsAssignRoomModalOpen(false);
            setAssignData({});
          }}
        />
      )}

      <ChipsDataTable
        apiURL={`${url.BASE_URL}${url.GET_IOT_DEVICE_LIST}`}
        title="Driver List"
        customStyles={customStyles}
        selectedRoomID={selectedRooms}
        columns={columns}
        isReload={isReload}
        idName={"Driverlist"}
        loading={loading}
        setLoading={setLoading}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        userId={userId}
        selectedPremise={selectedPremise}
        expandableRows={false}
        ExpandCollapseIcon={ExpandCollapseIcon}
        handleDeleteAll={handleDeleteAll}
      />
    </div>
  );
}

export default DriverList;

export const customStyles: any = {
  tableWrapper: {
    style: {
      minWidth: "1100px",
    },
  },
  subHeader: {
    style: {
      padding: "0px",
      margin: "0px",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#EFF2F7",
      fontWeight: "bold",
      fontSize: "14px",
      borderBottom: "none",
    },
  },
  rows: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
  cells: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
};

export const ExpandCollapseIcon = ({ expanded }: { expanded: boolean }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center  "
      style={{ cursor: "pointer", width: "32px", height: "32px" }}
    >
      <i
        className={`bx ${
          expanded ? "bx-caret-down" : "bx-caret-right"
        } text-dark fs-5`}
      ></i>
    </div>
  );
};
